import {
  ActionAddNewMiner,
  ActionAddNewMinerList,
  ActionClearRefreshing,
  ActionDeleteMiner,
  ActionRefreshMiner,
  ActionSetMiners,
  ActionSetOpenMiner,
  ActionSetRefreshing,
  ActionTypesStoredMiners,
} from "./actionTypes";
import { NewMinerI } from "@services/addNewMiner";
import { TabsTotals } from "@components/Pagination/Pagination.props";
import { IAdminMinerTableWithUnknown } from "@utils/hooks/useGetMinerList";
import { Tab } from "@store/minersSelect/actionTypes";
import { IAdminMinerTable } from "@services/getMinerInfo";

export function clearMiners() {
  return {
    type: ActionTypesStoredMiners.CLEAR_MINERS,
    payload: {},
  };
}

export function refreshMiner(miner: IAdminMinerTable): ActionRefreshMiner {
  return {
    type: ActionTypesStoredMiners.REFRESH_MINER,
    payload: miner,
  };
}

export function setMiners(value: IAdminMinerTableWithUnknown[], areUnknown: boolean, total: number, totals: TabsTotals): ActionSetMiners {
  return {
    type: ActionTypesStoredMiners.SET_MINERS,
    payload: {
      Miners: value,
      Total: total,
      TabsTotals: totals,
      AreUnknown: areUnknown,
    },
  };
}

export function setOpenMiner(id: string, reset?: boolean): ActionSetOpenMiner {
  return {
    type: ActionTypesStoredMiners.SET_OPEN_MINER,
    payload: { id, reset },
  };
}

export function addNewMiner(payload: NewMinerI): ActionAddNewMiner {
  return {
    type: ActionTypesStoredMiners.ADD_NEW_MINER,
    payload: { ...payload, isNew: true },
  };
}

export function addNewMinerList(payload: NewMinerI[]): ActionAddNewMinerList {
  return {
    type: ActionTypesStoredMiners.ADD_NEW_MINER_LIST,
    payload,
  };
}

export function deleteMiner(minerID: string, tab: Tab): ActionDeleteMiner {
  return {
    type: ActionTypesStoredMiners.DELETE_MINER,
    payload: { minerID, tab },
  };
}

export function setRefreshingMiners(): ActionSetRefreshing {
  return { type: ActionTypesStoredMiners.SET_REFRESHING };
}

export function clearRefreshingMiners(): ActionClearRefreshing {
  return { type: ActionTypesStoredMiners.CLEAR_REFRESHING };
}
